import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  customerUrl: string
  hydraToken: string
}

export type HydraGetShipToOption = {
  isDefaultOption?: boolean
  shipToAddress: {
    address1: string
    address2?: string
    city: string
    country: Alpha2CountryCode
    state: string
    zip: string
  }
  shipToName: {
    firstName: string
    lastName: string
    fullName: string
  }
  shipToOptionId: {
    unicity: number
  }
  shipToPhone: string
  href: string
}

export type HydraGetShipToOptionsResponse = {
  id: {
    unicity: number
  }
  href: string
  shipToOptions: HydraGetShipToOption[]
}

export const hydraGetShipToOptions = ({ customerUrl, hydraToken }: Props) => {
  const request: SendRequestType = {
    method: 'GET',
    baseURL: 'internal',
    url: `${customerUrl}/shipToOptions`,
    withAuth: true,
    token: hydraToken,
  }

  return httpTools.sendRequest<HydraGetShipToOptionsResponse>(request)
}
